import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'textVariant',
})(({ textVariant }) => ({
  ...(textVariant === 'body' && {
    fontSize: '20px',
    fontWeight: 500,
    color: '#262626',
  }),
  ...(textVariant === 'sub' && {
    fontSize: '18px',
    fontWeight: 500,
    color: '#666',
  }),
  ...(textVariant === 'label' && {
    fontSize: '16px',
    fontWeight: 600,
    color: '#262626',
  }),
  ...(textVariant === 'caption' && {
    fontSize: '14px',
    fontWeight: 400,
    color: '#737373',
  }),
  ...(textVariant === 'hint' && {
    fontSize: '12px',
    fontWeight: 400,
    color: '#737373',
  }),
}));

const CommonText = ({ variant = 'body', children, ...rest }) => (
  <StyledText textVariant={variant} {...rest}>
    {children}
  </StyledText>
);

export default CommonText;
